<template>
  <div class="field-holder">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .field-holder {
    margin-top: 14px;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    position: relative;
    min-height: 25px;

    &.split {
      flex: 50%;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding-right: 4px;
      width: 50%;

      label {
        margin-bottom: 0;
      }

      + .field-holder {
        &.split {
          padding-right: 0;
          padding-left: 4px;
        }
      }
    }

    &.inline {
      flex-direction: row;

      input + button,
      input + input {
        margin-left: 10px;
      }

      label {
        line-height: 28px;
        vertical-align: middle;
        margin-bottom: 0;
        line-height: 1.4em;
      }
    }

    &.split-column {
      flex: 1;
      flex-direction: column;
      width: 50%;
      min-width: 50%;
      align-items: center;
      justify-content: flex-start;
      padding-right: 10px;
      margin-top: 10px;
      min-height: 30px;

      + .split-column {
        margin-top: 10px;
        padding-right: 0;
        padding-left: 10px;
      }

      label {
        margin-right: 0;
      }
    }

    &.cleaned {
      margin: 0;
    }

    &.centralized {
      align-items: center;
      justify-content: center;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.row {
      display: flex;
      flex-direction: row;
      align-items: center;

      label {
        margin-bottom: 0;
      }
    }
  }
</style>

<script>
  export default {
    name: 'form-field-holder'
  }
</script>
